import React from 'react';
import PropTypes from 'prop-types';
import './_MatchDetailStatRow.scss';

const clampPercent = (value) => {
  if (!Number.isFinite(value)) return 50;
  return Math.max(0, Math.min(100, value));
};

const MatchDetailStatRow = ({ label, leftValue, rightValue, leftPercent, leftColor, rightColor, noValueColor }) => {
  const safeLeft = clampPercent(leftPercent);
  const safeRight = 100 - safeLeft;
  const gapRem = 1;
  const leftWidth = safeLeft === 0 ? '0%' : `calc(${safeLeft}% - ${gapRem / 2}rem)`;
  const rightWidth = safeRight === 0 ? '0%' : `calc(${safeRight}% - ${gapRem / 2}rem)`;

  return (
    <div className="match-detail-stat-row">
      <div className="match-detail-stat-row__values">
        <span className="match-detail-stat-row__value match-detail-stat-row__value--left">{leftValue}</span>
        <span className="match-detail-stat-row__label">{label}</span>
        <span className="match-detail-stat-row__value match-detail-stat-row__value--right">{rightValue}</span>
      </div>
      <div className="match-detail-stat-row__bar">
        <span className="match-detail-stat-row__bar-left" style={{ width: leftWidth, background: leftValue === 0 ? noValueColor : leftColor }} />
        <span className="match-detail-stat-row__bar-right" style={{ width: rightWidth, background: rightValue === 0 ? noValueColor : rightColor }} />
      </div>
    </div>
  );
};

MatchDetailStatRow.propTypes = {
  label: PropTypes.string,
  leftValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  rightValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  leftPercent: PropTypes.number,
  leftColor: PropTypes.string,
  rightColor: PropTypes.string,
  noValueColor: PropTypes.string
};

MatchDetailStatRow.defaultProps = {
  label: '',
  leftValue: 0,
  rightValue: 0,
  leftPercent: 50,
  leftColor: '#7cbadf',
  rightColor: '#d10a0a',
  noValueColor: '#979797'
};

export default MatchDetailStatRow;



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/FootballMatchDetail/Components/MatchDetailStatRow/MatchDetailStatRow.jsx